"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Preview;

var _react = _interopRequireWildcard(require("react"));

var _context = require("../context");

var _styled = require("./styled");

var _color = require("../../../styles/helpers/color");

function Preview() {
  var _useContext = (0, _react.useContext)(_context.ColorPickerContext),
      rgba = _useContext.rgba;

  var style = {
    backgroundColor: (0, _color.recomposeColor)({
      type: 'rgba',
      values: rgba
    })
  };
  return /*#__PURE__*/_react["default"].createElement(_styled.StyledPreview, {
    style: style
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/ColorPicker/commons/preview.js
// module id = D4qF
// module chunks = 0